import { Component, Input } from '@angular/core';
import { InboundFax } from '../../../core/models/inbound-fax.model';
import { DatePipe } from '@angular/common';
import { FaxStatusPipe } from '../../../shared/pipes/fax-status.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-inbound-fax-info',
    templateUrl: './inbound-fax-info.component.html',
    imports: [DatePipe, FaxStatusPipe, BlankValueDashPipe]
})
export class InboundFaxInfoComponent {
  @Input() inboundFax: InboundFax;
}
